import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const DatabaseIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Database Icon</title>;
    t1 = <path d="M4 18V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t2 = <path d="M20 6V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t3 = <path d="M12 10C16.4183 10 20 8.20914 20 6C20 3.79086 16.4183 2 12 2C7.58172 2 4 3.79086 4 6C4 8.20914 7.58172 10 12 10Z" stroke="currentColor" strokeWidth="1.5" />;
    t4 = <path d="M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12" stroke="currentColor" strokeWidth="1.5" />;
    t5 = <path d="M20 18C20 20.2091 16.4183 22 12 22C7.58172 22 4 20.2091 4 18" stroke="currentColor" strokeWidth="1.5" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props) {
    t6 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}</svg>;
    $[6] = props;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};